import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TNavigationTreeNode } from './navigation.models';
import * as NavigationActions from './navigation.action';
import * as NavigationSelectors from './navigation.selectors';
import { map } from 'rxjs/operators';
import { UnifiedLoginService } from '@monorepo/services';
//import { UnifiedLoginService } from '@monorepo/services';

@Injectable({
  providedIn: 'root',
})
export class NavigationFacade {
  constructor(private store: Store<TPlani8State>, private unifiedIdService: UnifiedLoginService) {}

  getNavigationInfoByFeature() {
    return this.store.pipe(select(NavigationSelectors.selectNavigation)).pipe(
      map((res) => ({
        ...res,
        navigationTreeList: res.navigationTreeList
          .map((tree) => {
            return this.#filterNavNodeByFeature(tree);
          })
          .filter((item) => item !== undefined) as TNavigationTreeNode[],
      })),
    );
  }

  selectNavigationItem(navigationTreeNode: TNavigationTreeNode) {
    this.store.dispatch(new NavigationActions.SelectNavigationItem(navigationTreeNode));
  }

  getSelectedNode() {
    return this.store.pipe(select(NavigationSelectors.selectNavigationItem));
  }

  setCustomPageHeader(val: string | null, showBack = false) {
    this.store.dispatch(new NavigationActions.SetCustomPageHeader(val, showBack));
  }

  resetCustomPageHeader() {
    this.store.dispatch(new NavigationActions.SetCustomPageHeader(null, false));
  }

  getCustomPageHeader() {
    return this.store.pipe(select(NavigationSelectors.getCustomPageHeader));
  }

  #filterNavNodeByFeature(treeNodes: TNavigationTreeNode) {
    if (treeNodes.children.length) {
      const updatedNavNode = {
        ...treeNodes,
        children: treeNodes.children.filter(
          (child) => child.featureId && this.unifiedIdService.isFeaturePermissionExist('PT_APP', child.featureId),
        ),
      };
      updatedNavNode.children = updatedNavNode.children
        .map((child) => this.#filterNavNodeByFeature(child))
        .filter((item) => item !== undefined) as TNavigationTreeNode[];

      return updatedNavNode;
    } else {
      if (treeNodes.featureId && this.unifiedIdService.isFeaturePermissionExist('PT_APP', treeNodes.featureId))
        return treeNodes;
      return undefined;
    }
  }
}

export type TGetNavigationInfo = ReturnType<NavigationFacade['getNavigationInfoByFeature']>;
export type TGetNavigationItem = ReturnType<NavigationFacade['getSelectedNode']>;
export type TGetCustomPageHeader = ReturnType<NavigationFacade['getCustomPageHeader']>;
